export function useRegisterPushToken(_isReady: boolean) {
  return null;
}

export default useRegisterPushToken;
